import { DownOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

interface IBTIconDownOutlinedProps extends IBTIconProps {
    rotateUp?: boolean;
}

export const BTIconDownOutlined: FunctionComponent<IBTIconDownOutlinedProps> = ({
    rotateUp = false,
    ...baseProps
}) => {
    const [props] = useAntIcon(baseProps);

    // -180 rotates from down to up on the right side (e.g ↓ → ↑)
    return <DownOutlined {...props} rotate={rotateUp ? -180 : 0} />;
};
